<template>
  <div class="player_performance_cnt">
    <div v-if="isloading" class="skeleton-loader-container">
      <template v-for="n in 2">
        <div :key="n" class="skeleton-attributes-block">
          <v-skeleton-loader type="heading" class="skeleton-heading"></v-skeleton-loader>
          <div class="skeleton-tabs">
            <v-skeleton-loader type="button" v-for="i in 4" :key="i" class="skeleton-tab"></v-skeleton-loader>
          </div>
          <div class="skeleton-players">
            <v-skeleton-loader type="avatar, text" v-for="i in 4" :key="i" class="skeleton-player"></v-skeleton-loader>
          </div>
        </div>
      </template>
    </div>
    <template v-else>
    <div class="performance_block">
      <div class="team_title">
        <figure>
          <img :src="gamedata.HomeTeam.logo" />
        </figure>
        <figcaption>
          {{ gamedata.HomeTeam.Name }} Performance Attributes
        </figcaption>
      </div>

      <div class="perfomance_players">
        <div class="player_tabs">
          <ul>
            <li
              @click="
                currentHometab = 1;
                synergyHome(currentHometab, 'Defensive IQ', 1);
              "
              v-bind:class="{ active: currentHometab == 1 }"
            >
              <a>Defensive IQ</a>
            </li>
            <li
              @click="
                currentHometab = 2;
                synergyHome(currentHometab, 'Interior Defense', 1);
              "
              v-bind:class="{ active: currentHometab == 2 }"
            >
              <a>Interior Defense</a>
            </li>
            <li
              @click="
                currentHometab = 3;
                synergyHome(currentHometab, 'Perimeter Defense', 1);
              "
              v-bind:class="{ active: currentHometab == 3 }"
            >
              <a>Perimeter Defense</a>
            </li>
            <li
              @click="
                currentHometab = 4;
                synergyHome(currentHometab, 'Defensive Impact', 1);
              "
              v-bind:class="{ active: currentHometab == 4 }"
            >
              <a>Defensive Impact</a>
            </li>
          </ul>
        </div>
        <div class="players_list">
          <template v-for="(player, index) in hometablist">
            <div class="player" :key="index">
              <div class="player_cnt">
                <figure>
                  <img
                    v-if="player.PLAYER_IMAGE"
                    :src="player.PLAYER_IMAGE"
                    :alt="player.FirstName + ' ' + player.LastName"
                  />
                  <img
                    v-else-if="player.PlayerID"
                    :src="
                      siteUrl +
                      '/api/viewfile?path=playerimages/sportsdataio/' +
                      player.PlayerID +
                      '.png'
                    "
                    :alt="player.FirstName + ' ' + player.LastName"
                    @error="handleImageError($event)"
                  />
                </figure>
                <strong>
                  {{ player.FirstName }} {{ player.LastName
                  }} <span>{{ player.Position }}</span>
                  
                          <div class="player_actions">
                  <div class="gradient_btn"><p>{{ player.sortdata }}<sub></sub></p></div>
   </div>

                  
                  </strong
                >
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="perfomance_players">
        <div class="player_tabs">
          <ul>
            <li
              @click="
                currentHometab1 = 1;
                synergyHome(currentHometab1, 'Offensive Impact', 2);
              "
              v-bind:class="{ active: currentHometab1 == 1 }"
            >
              <a>Offensive Impact</a>
            </li>
            <li
              @click="
                currentHometab1 = 2;
                synergyHome(currentHometab, 'Interior Scoring', 2);
              "
              v-bind:class="{ active: currentHometab1 == 2 }"
            >
              <a>Interior Scoring</a>
            </li>
            <li
              @click="
                currentHometab1 = 3;
                synergyHome(currentHometab, 'Attacking the Basket', 2);
              "
              v-bind:class="{ active: currentHometab1 == 3 }"
            >
              <a>Attacking the Basket</a>
            </li>
            <li
              @click="
                currentHometab1 = 4;
                synergyHome(currentHometab, 'Perimeter Scoring', 2);
              "
              v-bind:class="{ active: currentHometab1 == 4 }"
            >
              <a>Perimeter Scoring</a>
            </li>
          </ul>
        </div>
        <div class="players_list">
          <template v-for="(player, index) in hometablist2">
            <div class="player" :key="index">
              <div class="player_cnt">
                <figure>
                  <img
                    v-if="player.PLAYER_IMAGE"
                    :src="player.PLAYER_IMAGE"
                    :alt="player.FirstName + ' ' + player.LastName"
                  />
                  <img
                    v-else-if="player.PlayerID"
                    :src="
                      siteUrl +
                      '/api/viewfile?path=playerimages/sportsdataio/' +
                      player.PlayerID +
                      '.png'
                    "
                    :alt="player.FirstName + ' ' + player.LastName"
                    @error="handleImageError($event)"
                  />
                </figure>
                <strong>
                  {{ player.FirstName }} {{ player.LastName
                  }}<span>{{ player.Position }}</span>
                  
                          <div class="player_actions">
                  <div class="gradient_btn"><p>{{ player.sortdata }}<sub></sub></p></div>
   </div>

                  
                  </strong
                >
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="perfomance_players">
        <div class="player_tabs">
          <ul>
            <li
              @click="
                currentHometab2 = 1;
                synergyHome(currentHometab2, 'Ball Handing', 3);
              "
              v-bind:class="{ active: currentHometab2 == 1 }"
            >
              <a>Ball Handing</a>
            </li>
            <li
              @click="
                currentHometab2 = 2;
                synergyHome(currentHometab2, 'Perimeter Assists', 3);
              "
              v-bind:class="{ active: currentHometab2 == 2 }"
            >
              <a>Perimeter Assists</a>
            </li>
            <li
              @click="
                currentHometab2 = 3;
                synergyHome(currentHometab2, 'Interior Assists', 3);
              "
              v-bind:class="{ active: currentHometab2 == 3 }"
            >
              <a>Interior Assists</a>
            </li>
            <li
              @click="
                currentHometab2 = 4;
                synergyHome(currentHometab2, 'Draw Fouls', 3);
              "
              v-bind:class="{ active: currentHometab2 == 4 }"
            >
              <a>Free Throws</a>
            </li>
          </ul>
        </div>
        <div class="players_list">
          <template v-for="(player, index) in hometablist3">
            <div class="player" :key="index">
              <div class="player_cnt">
                <figure>
                  <img
                    v-if="player.PLAYER_IMAGE"
                    :src="player.PLAYER_IMAGE"
                    :alt="player.FirstName + ' ' + player.LastName"
                  />
                  <img
                    v-else-if="player.PlayerID"
                    :src="
                      siteUrl +
                      '/api/viewfile?path=playerimages/sportsdataio/' +
                      player.PlayerID +
                      '.png'
                    "
                    :alt="player.FirstName + ' ' + player.LastName"
                    @error="handleImageError($event)"
                  />
                </figure>
                <strong>
                  {{ player.FirstName }} {{ player.LastName
                  }}<span>{{ player.Position }}</span>

                  <div class="player_actions">
                  <div class="gradient_btn"><p>{{ player.sortdata }}<sub></sub></p></div>
   </div>

                  
                  </strong
                >
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="performance_block">
      <div class="team_title">
        <figure>
          <img :src="gamedata.AwayTeam.logo" />
        </figure>
        <figcaption>
          {{ gamedata.AwayTeam.Name }} Performance Attributes
        </figcaption>
      </div>
      <div class="perfomance_players">
        <div class="player_tabs">
          <ul style="font-size: 14px">
            <li
              @click="
                currentAwayTab = 1;
                synergyaway(currentAwayTab, 'Defensive IQ',1);
              "
              v-bind:class="{ active: currentAwayTab == 1 }"
            >
              <a>Defensive IQ</a>
            </li>
            <li
              @click="
                currentAwayTab = 2;
                synergyaway(currentAwayTab, 'Interior Defense',1);
              "
              v-bind:class="{ active: currentAwayTab == 2 }"
            >
              <a>Interior Defense</a>
            </li>
            <li
              @click="
                currentAwayTab = 3;
                synergyaway(currentAwayTab, 'Perimeter Defense',1);
              "
              v-bind:class="{ active: currentAwayTab == 3 }"
            >
              <a>Perimeter Defense</a>
            </li>
            <li
              @click="
                currentAwayTab = 4;
                synergyaway(currentAwayTab, 'Defensive Impact',1);
              "
              v-bind:class="{ active: currentAwayTab == 4 }"
            >
              <a>Defensive Impact</a>
            </li>
          </ul>
        </div>
        <div class="players_list">
          <template v-for="(player, index) in awaytablist">
            <div class="player" :key="index">
              <div class="player_cnt">
                <figure>
                  <img
                    v-if="player.PLAYER_IMAGE"
                    :src="player.PLAYER_IMAGE"
                    :alt="player.FirstName + ' ' + player.LastName"
                  />
                  <img
                    v-else-if="player.PlayerID"
                    :src="
                      siteUrl +
                      '/api/viewfile?path=playerimages/sportsdataio/' +
                      player.PlayerID +
                      '.png'
                    "
                    :alt="player.FirstName + ' ' + player.LastName"
                    @error="handleImageError($event)"
                  />
                </figure>
                <strong>
                  {{ player.FirstName }} {{ player.LastName
                  }}<span>{{ player.Position }}</span>
                  
                          <div class="player_actions">
                  <div class="gradient_btn"><p>{{ player.sortdata }}<sub></sub></p></div>
   </div>

                  </strong
                >
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="perfomance_players">
        <div class="player_tabs">
          <ul>
            <li
              @click="
                currentAwayTab1 = 1;
                synergyaway(currentAwayTab1, 'Offensive Impact', 2);
              "
              v-bind:class="{ active: currentAwayTab1 == 1 }"
            >
              <a>Offensive Impact</a>
            </li>
            <li
              @click="
                currentAwayTab1 = 2;
                synergyaway(currentAwayTab1, 'Interior Scoring', 2);
              "
              v-bind:class="{ active: currentAwayTab1 == 2 }"
            >
              <a>Interior Scoring</a>
            </li>
            <li
              @click="
                currentAwayTab1 = 3;
                synergyaway(currentAwayTab1, 'Attacking the Basket', 2);
              "
              v-bind:class="{ active: currentAwayTab1 == 3 }"
            >
              <a>Attacking the Basket</a>
            </li>
            <li
              @click="
                currentAwayTab1 = 4;
                synergyaway(currentAwayTab1, 'Perimeter Scoring', 2);
              "
              v-bind:class="{ active: currentAwayTab1 == 4 }"
            >
              <a>Perimeter Scoring</a>
            </li>
          </ul>
        </div>
        <div class="players_list">
          <template v-for="(player, index) in awaytablist2">
            <div class="player" :key="index">
              <div class="player_cnt">
                <figure>
                  <img
                    v-if="player.PLAYER_IMAGE"
                    :src="player.PLAYER_IMAGE"
                    :alt="player.FirstName + ' ' + player.LastName"
                  />
                  <img
                    v-else-if="player.PlayerID"
                    :src="
                      siteUrl +
                      '/api/viewfile?path=playerimages/sportsdataio/' +
                      player.PlayerID +
                      '.png'
                    "
                    :alt="player.FirstName + ' ' + player.LastName"
                    @error="handleImageError($event)"
                  />
                </figure>
                <strong>
                  {{ player.FirstName }} {{ player.LastName
                  }}<span>{{ player.Position }}</span>
                          <div class="player_actions">
                  <div class="gradient_btn"><p>{{ player.sortdata }}<sub></sub></p></div>
   </div>

                  
                  </strong
                >
              </div>
            </div>
          </template>
        </div>
      </div>

      <div class="perfomance_players">
        <div class="player_tabs">
          <ul>
            <li
              @click="
                currentAwayTab2 = 1;
                synergyaway(currentAwayTab2, 'Ball Handing', 3);
              "
              v-bind:class="{ active: currentAwayTab2 == 1 }"
            >
              <a>Ball Handing</a>
            </li>
            <li
              @click="
                currentAwayTab2 = 2;
                synergyaway(currentAwayTab2, 'Perimeter Assists', 3);
              "
              v-bind:class="{ active: currentAwayTab2 == 2 }"
            >
              <a>Perimeter Assists</a>
            </li>
            <li
              @click="
                currentAwayTab2 = 3;
                synergyaway(currentAwayTab2, 'Interior Assists', 3);
              "
              v-bind:class="{ active: currentAwayTab2 == 3 }"
            >
              <a>Interior Assists</a>
            </li>
            <li
              @click="
                currentAwayTab2 = 4;
                synergyaway(currentAwayTab2, 'Draw Fouls', 3);
              "
              v-bind:class="{ active: currentAwayTab2 == 4 }"
            >
              <a>Free Throws</a>
            </li>
          </ul>
        </div>
        <div class="players_list">
          <template v-for="(player, index) in awaytablist3">
            <div class="player" :key="index">
              <div class="player_cnt">
                <figure>
                  <img
                    v-if="player.PLAYER_IMAGE"
                    :src="player.PLAYER_IMAGE"
                    :alt="player.FirstName + ' ' + player.LastName"
                  />
                  <img
                    v-else-if="player.PlayerID"
                    :src="
                      siteUrl +
                      '/api/viewfile?path=playerimages/sportsdataio/' +
                      player.PlayerID +
                      '.png'
                    "
                    :alt="player.FirstName + ' ' + player.LastName"
                    @error="handleImageError($event)"
                  />
                </figure>
                <strong>
                  {{ player.FirstName }} {{ player.LastName
                  }}<span>{{ player.Position }}</span>
                          <div class="player_actions">
                  <div class="gradient_btn"><p>{{ player.sortdata }}<sub></sub></p></div>
   </div>

                  
                  </strong
                >
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    gamedata: null,
  },
  computed: {},
  methods: {
    handleImageError(event) {
      // Fallback to a default image or hide the image on error
      event.target.style.display = 'none';
    },
    synergyHome(currenttab, typed, list) {
      var _self = this;
      this.isloading = true;
      var attrs = [];
      
      // Map "Free Throws" label to "Draw Fouls" in ATTR
      var attrKey = typed;
      if (typed === "Free Throws") {
        attrKey = "Draw Fouls";
      }
      
      if (this.gamedata && this.gamedata.HomeLineup) {
        this.gamedata.HomeLineup.forEach((element) => {
          // Check if ATTR exists and is not empty
          if (element["ATTR"] && typeof element["ATTR"] === "object" && Object.keys(element["ATTR"]).length > 0) {
            // Try the mapped key first, then the original typed
            var attrValue = element["ATTR"][attrKey] || element["ATTR"][typed];
            if (attrValue !== undefined && attrValue !== null) {
              element.sortdata = (attrValue * 100).toFixed(0);
              attrs.push(element);
            }
          }
        });
      }
      
      if (attrs.length === 0) {
        // No players found with the requested attribute
      }
      
      // Use native sort if lodash is not available
      var nestedData;
      if (_self.lodash && _self.lodash.orderBy) {
        nestedData = _self.lodash.orderBy(attrs, ["sortdata"], ["desc"]);
      } else {
        nestedData = attrs.sort(function(a, b) {
          var aVal = parseFloat(a.sortdata) || 0;
          var bVal = parseFloat(b.sortdata) || 0;
          return bVal - aVal;
        });
      }

      if (list == 1) {
        this.hometablist = nestedData.slice(0, 4);
      }
      else if (list == 2) {
        this.hometablist2 = nestedData.slice(0, 4);
      }
      else if (list == 3) {
        this.hometablist3 = nestedData.slice(0, 4);
      }
      this.isloading = false;
    },
    synergyaway(currenttab, typed, list) {
      var _self = this;
      this.isloading = true;

      var attrs = [];
      
      // Map "Free Throws" label to "Draw Fouls" in ATTR
      var attrKey = typed;
      if (typed === "Free Throws") {
        attrKey = "Draw Fouls";
      }
      
      if (this.gamedata && this.gamedata.AwayLineup) {
        this.gamedata.AwayLineup.forEach((element) => {
          // Check if ATTR exists and is not empty
          if (element["ATTR"] && typeof element["ATTR"] === "object" && Object.keys(element["ATTR"]).length > 0) {
            // Try the mapped key first, then the original typed
            var attrValue = element["ATTR"][attrKey] || element["ATTR"][typed];
            if (attrValue !== undefined && attrValue !== null) {
              element.sortdata = (attrValue * 100).toFixed(0);
              attrs.push(element);
            }
          }
        });
      }

      if (attrs.length === 0) {
        // No players found with the requested attribute
      }

      // Use native sort if lodash is not available
      var nestedData;
      if (_self.lodash && _self.lodash.orderBy) {
        nestedData = _self.lodash.orderBy(attrs, ["sortdata"], ["desc"]);
      } else {
        nestedData = attrs.sort(function(a, b) {
          var aVal = parseFloat(a.sortdata) || 0;
          var bVal = parseFloat(b.sortdata) || 0;
          return bVal - aVal;
        });
      }

      if (list == 1) {
        this.awaytablist = nestedData.slice(0, 4);
      }
      else if (list == 2) {
        this.awaytablist2 = nestedData.slice(0, 4);
      }
      else if (list == 3) {
        this.awaytablist3 = nestedData.slice(0, 4);
      }
      this.isloading = false;
    },
  },
  watch: {},
  mounted() {
    this.synergyHome(this.currentHometab, "Defensive IQ", 1);
    this.synergyHome(this.currentHometab1, "Offensive Impact", 2);

    this.synergyHome(this.currentHometab2, "Ball Handing", 3);

    this.synergyaway(this.currentAwayTab, "Defensive IQ", 1);
    this.synergyaway(this.currentAwayTab1, "Offensive Impact", 2);

    this.synergyaway(this.currentAwayTab2, "Ball Handing", 3);

    this.siteUrl = process.env.VUE_APP_API_URL;
  },
  data() {
    return {
      siteUrl: 1,
      currentHometab: 1,
      currentHometab1: 1,
      currentHometab2: 1,
      currentAwayTab: 1,
      currentAwayTab1: 1,
      currentAwayTab2: 1,
      hometablist: [],
      awaytablist: [],
      hometablist2: [],
      hometablist3: [],
      awaytablist2: [],
      awaytablist3: [],
      isloading: false,
    };
  },
};
</script>

<style scoped>
.skeleton-loader-container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.skeleton-attributes-block {
  padding: 20px;
  background: #1a1a2e;
  border-radius: 8px;
}

.skeleton-heading {
  margin-bottom: 20px;
  height: 24px;
}

.skeleton-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.skeleton-tab {
  width: 120px;
  height: 40px;
}

.skeleton-players {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
}

.skeleton-player {
  padding: 15px;
  background: #0f1419;
  border-radius: 8px;
}
</style>
